import { getPermissao, temPermissao } from "../utils/permissoes";

export default function usePermissao(modulo) {
  return {
    nivel: getPermissao(modulo),
    canView: temPermissao(modulo, "view"),
    canEdit: temPermissao(modulo, "edit"),
  };
}
